const localStorageKeyNames = [
    'HekateHeartBeatFormInjection',
    'HekateQueryStringFormInjection',
    'SplitTestingPlugin',
    'PersonalizationProfile',
    'AiAdvisorConversationId',
    'GetStartedAccountActivated',
    'OffsiteReferringUrl',
    'EbookHTML',
    'HekateProgressiveProfiles',
    'ClosedBanners',
    'WaTag', // unique user id
    'WaThrottled', // flag for if will push requests or not
];
export const isValidLocalStorageKeyName = (key) => {
    return localStorageKeyNames.includes(key);
};
const sessionStorageKeyNames = [
    'VwoTestInfo',
    'CrossSessionFetchThrottle',
    'WwwSession',
    'AiAdvisorInfo',
];
export const isValidSessionStorageKeyName = (key) => {
    return sessionStorageKeyNames.includes(key);
};
/** Cookies that we set */
const validCookieNames = [
    'OptanonConsent', // cookie that OneTrust Sets
    'emailVarForPreferenceCenter',
    'x-www-is-internal-developer', // from crossSession (i.e cross-session.jsp), true if the user visits heartBeat from a dev server
    'x-www-have-seen-on' /** from crossSession (i.e cross-session.jsp),
                  the timestamp in milliseconds when the user has had an "on" cookie, meaning they have logged in to the product at some point */,
];
export const isValidCookieName = (key) => {
    return validCookieNames.includes(key);
};
export const wwwPrefix = 'www-';
